/**
 * Warns the customer that an FSC-code-only product does not include map files,
 * at the moment they press Add to Cart.
 *
 * The listener is registered on document in the capture phase so that it runs
 * before ProductForm's own submit handler, which is bound directly to the form.
 * Stopping propagation there prevents the add request from being sent until the
 * customer has made a choice.
 *
 * Any failure here must leave Add to Cart working, so the whole thing is
 * wrapped and bails out quietly rather than blocking a sale.
 */
(function () {
  'use strict';

  try {
    var modal = document.getElementById('FscOnlyModal');
    if (!modal || typeof modal.showModal !== 'function') return;

    // Set once the customer has chosen to continue, so the resubmitted form
    // passes straight through instead of reopening the dialog.
    var acknowledged = false;
    var pendingForm = null;

    /**
     * Products that ask for a VIN validate it in vin-input.liquid, on a submit
     * listener bound to the form itself. This listener is on document, so it
     * runs first, and interrupting here would hide that error behind the
     * dialog. While the VIN is still incomplete we stay out of the way and let
     * the VIN guard show its message; the dialog appears on the next attempt,
     * once the VIN is filled in.
     *
     * The rule mirrors sanitize()/isValid() in vin-input.liquid.
     */
    function vinIncomplete() {
      var container = document.querySelector('.vin-field[data-vin-mode]');
      if (!container) return false;

      var input = container.querySelector('#vincheck');
      if (!input) return false;

      var mode = container.getAttribute('data-vin-mode');
      var value = (input.value || '').replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();

      if (mode === 'entervin17') return !(value.length === 7 || value.length === 17);
      return value.length !== 7;
    }

    function isAddToCartForm(form) {
      return (
        form instanceof HTMLFormElement &&
        typeof form.action === 'string' &&
        form.action.indexOf('/cart/add') !== -1
      );
    }

    modal.addEventListener('close', function () {
      if (!acknowledged) pendingForm = null;
    });

    document.addEventListener(
      'submit',
      function (event) {
        if (acknowledged) return;
        if (!isAddToCartForm(event.target)) return;
        if (vinIncomplete()) return;

        event.preventDefault();
        event.stopPropagation();

        pendingForm = event.target;
        modal.showModal();
      },
      true
    );

    var closeButton = modal.querySelector('[data-fsc-only-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        modal.close();
      });
    }

    // Clicking the backdrop targets the dialog itself, not its contents.
    modal.addEventListener('click', function (event) {
      if (event.target === modal) modal.close();
    });

    var continueButton = modal.querySelector('[data-fsc-only-continue]');
    if (continueButton) {
      continueButton.addEventListener('click', function () {
        acknowledged = true;
        modal.close();

        if (!pendingForm) return;

        // requestSubmit fires a submit event, so ProductForm still handles the
        // add over AJAX. Fall back to submit() on browsers that lack it, which
        // adds the item via a full page load rather than failing.
        if (typeof pendingForm.requestSubmit === 'function') {
          pendingForm.requestSubmit();
        } else {
          pendingForm.submit();
        }
      });
    }
  } catch (error) {
    // Deliberately swallowed: a broken warning must never block Add to Cart.
  }
})();
